var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2509 40H18.7503C18.7544 36.8461 21.2702 34.2904 24.3748 34.2863H27.1877V25.4288C23.6525 24.7007 20.5298 22.6156 18.4698 19.6075C14.0201 21.0248 9.28192 18.5094 7.88675 13.9891C7.63098 13.1605 7.50058 12.2972 7.5 11.4287V5.71375H15.9374V0H44.0626V5.71375H52.5V11.4287C52.4968 16.166 48.7139 20.0036 44.0507 20.0004C43.1958 19.9998 42.346 19.8673 41.5302 19.6075C39.4706 22.6159 36.3477 24.7012 32.8123 25.4288V34.2863H35.6251C38.7303 34.2897 41.2469 36.8456 41.2509 40ZM25.9868 4.92125V8.66H28.0491V19.7738H32.1503V4.92125H25.9868ZM44.0626 8.57125V11.4287C44.0646 13.1691 43.7527 14.8951 43.1422 16.5212C43.4458 16.5778 43.7539 16.6066 44.0626 16.6075C46.8769 16.6047 49.1578 14.2877 49.1605 11.4287V8.57125H44.0626ZM10.8395 8.57125V11.4287C10.8423 14.2877 13.1231 16.6047 15.9374 16.6075C16.2465 16.6066 16.555 16.5777 16.8591 16.5212C16.2483 14.8952 15.9359 13.1692 15.9374 11.4287V8.57125H10.8395Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPlace);
export default __webpack_public_path__ + "static/media/first-place.628ab003512b74977f8f1a35b7f44328.svg";
export { ForwardRef as ReactComponent };